var _path, _path2, _path3, _path4, _path5, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 457,
    viewBox: "0 0 480 457",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M287 383.5H421.5L479.5 441.5",
    stroke: "#1D1D1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.99942 108.28L37.6815 72H259.895L288 100.104",
    stroke: "#61FF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M287.5 100.5V175.5L315.5 219V347.5L287.5 383.5",
    stroke: "#1D1D1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M257 23H188.222L169 3",
    stroke: "#1D1D1D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.5 455.78H228.5L315.5 347.5V317.5",
    stroke: "#F2F2F2",
    strokeOpacity: 0.38
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 2,
    r: 2,
    fill: "#1D1D1D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr);
export default __webpack_public_path__ + "static/media/tr.3f75efbf896f5f74bb5231fd42606edb.svg";
export { ForwardRef as ReactComponent };